import { connect } from 'react-redux'
import ShippingTypes from '../components/shipping_types'

const mapStateToProps = (state) => {
  return {
    quotes: state.checkout.quotes,
    selectedQuote: state.checkout.selectedQuote,
    shippingDiscount: state.checkout.shippingDiscount,
    backorder: state.checkout.backorder,
    checkoutPath: state.checkout.checkoutPath
  }
}

const mapDispatchToProps = (dispatch) => {

  return {
    onMethodSelected: (quote, checkoutPath) => {
      if (checkoutPath && checkoutPath == '/flatspin-checkout') {
        var route = 'flat_spin_checkout_update_shipping_path';

      }

     else {
       var route = 'checkout_update_shipping_path';

     }

      let payload = { shipping_quote: {code: quote.code} };
        dispatch({ type:"SELECT_SHIPPING",
          quote: quote
        })
      $.ajax({
        url: Routes[route]({ format: "json" }),
        type: 'PUT',
        contentType: 'application/json',
        data: JSON.stringify(payload),
        dataType: 'json',
        beforeSend: function(){
          $(".continue-button").attr("disabled","disabled");
        },
        success: function(data){

          if (checkoutPath == '/flatspin-checkout') {

            window.location.reload();

          }
        else {

          $(".continue-button").removeAttr("disabled")
        }
        }
      });
    }
  };
}

const ShippingTypeSelector = connect(mapStateToProps, mapDispatchToProps)(ShippingTypes);

export default ShippingTypeSelector;
